import { RemoteConfigParameters } from '~/config/firebase/remote-config-types';
import { createRemoteConfigApi } from '~/config/firebase/remote-config-utils';

const remoteConfigParameters = {
  residentialMowersSupport: { key: 'residential_mowers_support', type: 'string' },
  bleSettingsCompat: { key: 'ble_settings_compat', type: 'string' },
  eposInstallationCompat: { key: 'epos_installation_compat', type: 'string' },
  npsSurveyIntervalDays: { key: 'nps_survey_interval_days', type: 'number' },
  greenkeeperEnabled: { key: 'greenkeeper_enabled', type: 'boolean' },
  dashboardReactivityUpgrade: { key: 'dashboard_reactivity_upgrade', type: 'string' },
  cookieConsentEnabled: { key: 'cookie_consent_enabled', type: 'boolean' },
  swipeRefetchPixelsDistance: { key: 'swipe_refetch_pixels_distance', type: 'number' },

  newTagsEnabled: { key: 'new_tags_enabled', type: 'boolean' },
  appStatusConfig: { key: 'app_status_config', type: 'string' },
  filterDrawerEnabled: { key: 'filter_drawer_enabled', type: 'string' },
  facilityModeSettingEnabled: { key: 'facility_mode_setting_enabled', type: 'boolean' },
  measurementSystemPreferenceEnabled: {
    key: 'measurement_system_preference_enabled',
    type: 'boolean',
  },
  showGatewayAssetList: { key: 'show_gateway_asset_list', type: 'string' },
  wsIdleDisconnect: { key: 'ws_idle_disconnect_enabled', type: 'boolean' },
  showGatewayLocation: { key: 'show_gateway_location', type: 'string' },
  manufacturedDateEnabled: { key: 'manufactured_date_enabled', type: 'boolean' },
  smartRoutinesEnabled: { key: 'smart_routines_enabled', type: 'boolean' },
  mowerReferenceStationModelEnabled: {
    key: 'mower_reference_station_model_enabled',
    type: 'boolean',
  },
  mowerCheckFotaEnabled: { key: 'mower_check_fota_enabled', type: 'boolean' },
  inventoryV2List: { key: 'inventory_v2_list', type: 'boolean' },
  mapSyncOverlayMessageDebugEnabled: {
    key: 'map_sync_overlay_message_debug_enabled',
    type: 'boolean',
  },
  advancedMowerSitemapObjectsListEnabled: {
    key: 'advanced_mower_sitemap_objects_list_enabled',
    type: 'boolean',
  },
  advancedMowerSitemapObjectsListAdvancedView: {
    key: 'advanced_mower_sitemap_objects_list_advanced_view_enabled',
    type: 'boolean',
  },
} as const satisfies RemoteConfigParameters;

const {
  hooks: remoteConfigHooks,
  initRemoteConfig,
  refetchWithSignals,
  resetRemoteConfig,
} = createRemoteConfigApi(remoteConfigParameters);

export { initRemoteConfig, refetchWithSignals, resetRemoteConfig };

export const {
  useGetBleSettingsCompat,
  useGetEposInstallationCompat,
  useGetResidentialMowersSupport,
  useGetGreenkeeperEnabled,
  useGetNpsSurveyIntervalDays,
  useGetCookieConsentEnabled,
  useGetDashboardReactivityUpgrade,
  useGetSwipeRefetchPixelsDistance,
  useGetNewTagsEnabled,
  useGetAppStatusConfig,
  useGetFilterDrawerEnabled,
  useGetFacilityModeSettingEnabled,
  useGetMeasurementSystemPreferenceEnabled,
  useGetShowGatewayAssetList,
  useGetWsIdleDisconnectEnabled,
  useGetShowGatewayLocation,
  useGetManufacturedDateEnabled,
  useGetSmartRoutinesEnabled,
  useGetMowerReferenceStationModelEnabled,
  useGetMowerCheckFotaEnabled,
  useGetInventoryV2ListEnabled,
  useGetMapSyncOverlayMessageDebugEnabled,
  useGetAdvancedMowerSitemapObjectsListEnabled,
  useGetAdvancedMowerSitemapObjectsListAdvancedViewEnabled,
} = remoteConfigHooks;
